import DateTimeRange from "@/core/types/DateTimeRange";
import Serializable from "@/core/misc/mixins/Serializable";
import TimeZone from "@/domains/TimeZones/TimeZone";

class RpcMetaTime extends Serializable {
    /** Временная зона клиента/сервера */
    timeZone: TimeZone | null;
    /** Временные метки сервера */
    serverTime: DateTimeRange | null;
    /** Время выполнения запроса в миллисекундах */
    executionTime: number | null;

    static fromRequest(timeZone: TimeZone) : RpcMetaTime {
        const obj = new this();

        obj.timeZone = timeZone;

        return obj;
    }
}

export default RpcMetaTime;
